import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'timeNumberToString'
})
export class TimeNumberToStringPipe implements PipeTransform {

  transform(timeInMinutes: number): string {
    let ret: string = null;

    if (timeInMinutes !== null) {
      // NB : Date is in milliseconds
      const date = new Date(timeInMinutes * 60 * 1000);

      const hours = date.getUTCHours();
      const hh = (hours < 10) ? '0' + hours : '' + hours;

      const minutes = date.getUTCMinutes();
      const mm = (minutes < 10) ? '0' + minutes : '' + minutes;

      ret = hh + ':' + mm;
    }

    return ret;
  }

}
